import styled from "styled-components";
import { ButtonCommon } from "../../../../Layout/styled";
import { InputContainer } from "../../../../components/Common/Input/styled";

export const LaunchFormContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-height: calc(100vh - 250px);
  &::before,
  &::after {
    content: "";
    position: absolute;
    pointer-events: none;
  }
  &::before {
    left: 0;
    background: url("/assets/images/form/bg_launch_form.png") no-repeat center /
      cover;
    width: 100%;
    height: 100vh;
  }
  &::after {
    width: 817px;
    height: 817px;
    border-radius: 50%;
    opacity: 0.32;
    background: radial-gradient(
      51.22% 71.35% at 50.93% 49.22%,
      #ff394a 0%,
      rgba(255, 57, 74, 0) 100%
    );
    filter: blur(200px);
  }
  &.hide {
    &::before,
    &::after {
      content: none;
    }
  }
`;
export const LaunchFormWrapper = styled.div`
  position: relative;
  z-index: 10;
  max-width: 450px;
  margin: 0 auto;
  & > div > ${ButtonCommon} {
    width: 204px;
    margin: 32px auto 0;
  }
  & > div > h2 {
    color: #fff;
    font-family: DirtyLine;
    margin-bottom: 10px;
    text-align: center;
    font-size: 32px;
    line-height: 96%;
    text-transform: lowercase;
  }
  & > div > p {
    color: #92929e;
    text-align: center;
    font-family: Syne;
    font-size: 15px;
    line-height: 19.2px;
  }
`;
export const LaunchFormTime = styled.div`
  max-width: 240px;
  width: 100%;
  margin: 150px auto 0;
  padding: 8px 24px;
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(22px);
  & > div {
    &:nth-child(1) {
      display: flex;
      gap: 10px;
    }
    p {
      color: #92929e;
      text-align: center;
      font-family: Syne;
      font-size: 13px;
      line-height: 19.2px;
    }
  }
`;
export const FormTimer = styled.div`
  color: #92929e;
  text-align: center;
  font-family: Syne;
  font-size: 13px;
  line-height: 19.2px;
  & > span {
    position: relative;
    display: block;
    height: 10px;
    border-radius: 10px;
    background: rgba(255, 255, 255, 0.15);
    margin-top: 10px;
    overflow: hidden;
    &::before {
      content: "";
      position: absolute;
      left: 0;
      top: 0;
      width: 90%;
      height: 10px;
      border-radius: 30px;
      background: linear-gradient(90deg, rgba(255, 255, 255, 0) 0%, #fff 100%);
    }
  }
`;
export const LaunchFormStep = styled.div`
  padding-bottom: 50px;
`;
export const FormStepBody = styled.div`
  ${ButtonCommon} {
    width: max-content;
  }
  ${InputContainer} {
    border-bottom: 1px solid #3a3a40;
    input {
      padding: 8px 0;
      font-size: 14px;
    }
  }
  .form-row {
    &:not(:last-child) {
      margin-bottom: 12px;
    }
    input {
      width: 100%;
      padding: 10px 0;
      outline: none;
      border: none;
      color: #fff;
      border-bottom: 1px solid #fff;
      background-color: transparent;
      &.ant-input-outlined {
        background-color: transparent;
        &:focus,
        &:focus-within {
          border-color: transparent;
          box-shadow: unset !important;
        }
      }
      &::placeholder {
        color: #989898;
        opacity: 1;
      }
      &::-ms-input-placeholder {
        color: #989898;
      }
    }
  }
  .button-change-page {
    background: unset;
    outline: none;
    border: 0;
    color: var(--Neutral-White, #fff);
    font-family: Syne;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 125%; /* 17.5px */
    cursor: pointer;
    transition: opacity 0.26s ease;
    border-radius: 7.2px;
    border: 1.35px solid var(--Red-900, #7b2121);
    background: var(--Red-600, #d83b3b);
    box-shadow: 0px 3.6px 3.6px 0px rgba(0, 0, 0, 0.25),
      0px 2.7px 0px 0px rgba(255, 255, 255, 0.25) inset;
    padding: 9px 18px;
    &:hover {
      opacity: 0.7;
    }
  }
`;
export const LaunchStartForm = styled.div`
  position: relative;
  z-index: 10;
  max-width: 770px;
  margin: 0 auto;
  padding: 0 15px;
`;
export const StartFormVisual = styled.div`
  margin-bottom: 12px;
`;
export const StepBodyBlock = styled.div`
  padding: 20px;
  border-radius: 8px;
  background: #1b1b1b;
  border-left: 3px solid transparent;
  transition: all 0.15s linear;
  &:not(:last-child) {
    margin-bottom: 12px;
  }
  &:hover {
    border-color: #e84142;
  }
  h3 {
    color: #fff;
    font-size: 14px;
    font-weight: 500;
  }
  .body-content {
    .ant-upload-list-item-name {
      color: #fff;
      font-size: 12px;
      font-style: normal;
      font-weight: 400;
      line-height: 12px; /* 100% */
      padding-left: 0 !important;
    }
    .ant-upload-icon {
      display: none;
    }
    .ant-btn-icon {
      svg {
        fill: #fff;
      }
    }
    .ant-btn.ant-btn-text.ant-btn-sm.ant-btn-icon-only.ant-upload-list-item-action {
      opacity: 1 !important;
    }
  }
`;
export const FormStepButtons = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  margin-top: 46px;
`;
export const ButtonUploadForm = styled.button`
  display: flex;
  align-items: center;
  border-radius: 4px;
  border: 1px dashed #525252;
  background-color: transparent;
  color: #8e8e8e;
  min-height: 32px;
  margin-top: 12px;
  transition: all 0.15s linear;
  cursor: pointer;
  &:hover {
    opacity: 0.75;
  }
  figure {
    width: 17px;
    height: 16px;
    margin-right: 8px;
  }
  span {
    color: #cc8787;
    margin-left: 5px;
  }
`;
export const StepBlockSupport = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  font-size: 12px;
  margin-top: 15px;
  p {
    font-family: DMMono-400;
    color: #fff;
  }
`;
